/**
 * One place that turns a failed auth response into the sentence the form
 * shows. A rate limit (429) is never "Something went wrong": it says how long
 * to wait, from the body's retry_after_seconds, else the Retry-After header.
 * A body that is not JSON (a proxy's HTML error page) must not throw the form
 * into the "Network error" branch either, so parse it defensively.
 */
export const GENERIC_ERROR = 'Something went wrong';
export const NETWORK_ERROR = 'Network error — please try again';

export async function readJson(res) {
  try {
    return (await res.json()) || {};
  } catch {
    return {};
  }
}

export function waitMinutes(res, data) {
  const fromBody = Number(data && data.retry_after_seconds);
  let fromHeader = NaN;
  if (res && res.headers && typeof res.headers.get === 'function') {
    fromHeader = Number(res.headers.get('retry-after'));
  }
  const secs = fromBody > 0 ? fromBody : fromHeader > 0 ? fromHeader : 0;
  return secs ? Math.max(1, Math.ceil(secs / 60)) : null;
}

export function tooManyAttempts(minutes) {
  return `Too many attempts — try again in ${minutes} minute${minutes === 1 ? '' : 's'}.`;
}

export function errorMessage(res, data, fallback = GENERIC_ERROR) {
  if (res && res.status === 429) {
    const minutes = waitMinutes(res, data);
    if (minutes) return tooManyAttempts(minutes);
    return (data && data.detail) || 'Too many attempts — try again in a few minutes.';
  }
  return (data && data.detail) || fallback;
}
